<template>
    <div class="alarm_history_container"
    :class="[
    { 'no-permission-wrap': !noPermission() }
    ]">
      <div
        class="Tb_search_wrap alarm"
        :class="[
        { support: ['support-resistance', 'rocket'].includes(subPath)},
        { premium: subPath == 'premium'},
        ]"
        v-if="noPermission()"
      >
        <form>
          <div class="search_wrp">
            <input type="text" id="search" name="search" class="search_input" :placeholder="$t('alarm.score.searchCoin')"
              v-model="searchQuery" />
            <button class="search_clear" @click="clearSearch"></button>
          </div>
        </form>
      </div>
  
      <div 
      class="history_list_warp" 
      :class="[
      { support: subPath === 'support-resistance' },
      { rocket: subPath === 'rocket' },
      { score: subPath === 'score' },
      { 'no-permission': !noPermission() }
      ]">
        <!-- 로딩바 -->
        <div class="subPage_container" v-if="!loadApi || !loadingStatus">
          <div class="loading_spinner">
            <div class="loading_circle"></div>
          </div>
        </div>
        
        <!-- 스마트 시그널 권한 없을 경우 -->
        <div v-else-if="subPath == 'smart' && !okSmart" class="ps_nodata mt110s" style="text-align: center">
          <h4 v-dompurify-html="$t('alarm.guideMent.smart')"></h4>
        </div>
          
        <!-- 프리미엄 프로 시그널 권한 없을 경우 -->
        <div v-else-if="type == 'premium-pro' && !userProPermission" class="ps_nodata mt110s" style="text-align: center">
          <h4 v-dompurify-html="$t('alarm.guideMent.prePro')"></h4>
        </div>
        
        <!-- 3000 이하 알람 구매 x -->
        <div v-else-if="!noPermission()" class="ps_nodata mt110s" style="text-align: center">
          <h4>{{ $t('alarm.guideMent.access1') }}<br />{{ $t('alarm.guideMent.access2') }}</h4>
        </div>

        <!-- 스코어, 급등락, 로켓 데이터 없을 경우 -->
        <div v-else-if="subPath == 'score'  && filteredHistory.length == 0 || subPath == 'rocket' && filteredHistory.length == 0" class="ps_nodata">
            {{ $t("alarm['rsi']['noSignal']") }}<br />{{ $t("alarm['rsi']['later']") }}
          </div>
  
        <div v-else-if="subPath != 'score' && subPath != 'rocket' && insightList.length == 0" class="ps_nodata">
          {{ $t("price['noData']") }} <br />{{ $t("price['needReg']") }}
        </div>
  
        <div v-else-if="subPath != 'score' && subPath != 'rocket' && insightList.length > 0 && filteredHistory.length == 0" class="ps_nodata">
          <div v-if="insingtChk.length > 0">
            {{ $t("alarm['rsi']['noSignal']") }}<br />{{ $t("alarm['rsi']['later']") }}
          </div>
          <div v-else>
            <h4>{{ $t('alarm.guideMent.beforeCoin1') }}<br />{{ $t('alarm.guideMent.beforeCoin2') }}</h4>
          </div>
        </div>

        <div class="Tb_data_rapid" v-else>
          <ul>
            <li v-for="(history, i) in filteredHistory" :key="i" @click="() => navigateToChart({ symbol: history, i })">
              <div class="history_list_container">
                <div class="history_info_wrap">
                  <div class="coin_wrap">
                    <div class="coin_img"  v-if="subPath === 'rocket'">
                      <img src="@/assets/images/common/rocket.svg" />
                    </div>
                    <div class="coin_img" v-else>
                      <img :src="getImagePath(history.coin)"
                        @error="handleImageError(history.coin, $event)" />
                    </div>
  
                    <div class="coin_name" v-if="subPath === 'rocket'">
                      <h5>
                        {{ history.coin }}
                      </h5>
                      <h6 class="txt_time">
                        {{ history.exchange }}
                      </h6>
                    </div>
                    
                    <div class="coin_name" v-else>
                      <h5>
                        {{ history.coin }}<span v-if="windowWidth >= 400">/{{ history.quote }}</span>
                      </h5>
  
                      <h6 class="txt_time" v-if="type === 'score' && windowWidth > 480">
                        <span >{{ $t("alarm.score.score") }}: </span> <em :class="history.score > 0 ? 'plus' : 'minus'">{{ history.score > 0 ? '+' : '' }} {{ history.score }}</em>
                      </h6>
                      <h6 class="txt_time" v-if="type === 'score' && windowWidth <= 480">
                        <span >{{ $t("alarm.score.score") }} </span> <br/> <em :class="history.score > 0 ? 'plus' : 'minus'">{{ history.score > 0 ? '+' : '' }} {{ history.score }}</em>
                      </h6>
  
                      <h6 class="txt_time" v-if="type === 'volatility'">
                        <span v-dompurify-html="responsiveText($t(`alarm['volume']['past']`), history.pre)"></span>
                      </h6>
  
                      <h6 class="txt_time" v-if="['smart', 'smart-pro', 'premium', 'premium-pro'].includes(type)">
                        {{ history.exchange }}
                      </h6>
  
                      <h6 class="txt_time" v-if="subPath === 'support-resistance' && history.position">
                        {{ history.exchange }} <em>${{ history.price }}</em>
                      </h6>
                    </div>
  
                   
                  </div>
  
                  <div class="sign_box_container">
                    <div 
                    v-if="type === 'volatility'" 
                    class="sign_box" 
                    :class="[
                      history.volatility > 0 ? 'plus' : 'minus',
                      getVolatilityClass(history.volatility)
                    ]"
                    >
                      {{ history.volatility }}
                    </div>
  
                    <div v-else class="sign_box" :class="[getSignBoxClass(history), { rocket: type == 'rocket'}, type]">
                      <template v-if="type === 'score'">
                        {{ history.count > 1 ? $t('alarm["score"]["continue"]', { count: history.count }) :
                          $t("alarm['score']['new']") }}
                      </template>
                      <template v-else-if="['smart', 'smart-pro', 'premium', 'premium-pro', 'rsi'].includes(type)">
                        <!-- <img v-if="type === 'smart-pro' && ['L'].includes(history.type)"
                          src="@/assets/images/dark/prevL.svg" />
                        <img v-else-if="type === 'smart-pro' && ['S'].includes(history.type)"
                          src="@/assets/images/dark/prevS.svg" /> -->
                        <div v-if="type === 'smart-pro' && ['L'].includes(history.type)" class="sign__box-content">
                          <img src="@/assets/images/alarm/smart/smart-sign.png" /> {{ history.type }}
                        </div>
                        <div  v-else-if="type === 'smart-pro' && ['S'].includes(history.type)" class="sign__box-content">
                          <img src="@/assets/images/alarm/smart/smart-sign.png" /> {{ history.type }}
                        </div>
                         <div  v-else-if="type === 'rsi'">
                          RSI {{ history.type }}
                        </div>
                        <div v-else>
                          {{ history.type }}
                        </div>
                      </template>
                      <template v-else-if="subPath === 'support-resistance' && history.position">
                        <div class="sr-signal" v-dompurify-html="history.position.includes('Buy') ? `<span>▽ 1% to</span> ${history.position.replace('Buy', 'SUP')}` : `<span>△ 1% to</span> ${history.position.replace('Sell', 'RES')}`"></div>
                      </template>
                      <template v-else-if="subPath === 'rocket'">
                        {{ history.type == 'S' ? `🚀 Rocket  ↓↓↓` : `🚀 Rocket  ↑↑↑` }}
                      </template>
                    </div>
  
                    <h6 class="txt_time" v-if="type === 'volatility'">
                      <span v-dompurify-html="responsiveText($t(`alarm['volume']['current']`), history.current)"></span>
                    </h6>
  
                    <h6 class="txt_time" v-if="type != 'volatility'">
                      <em>{{ history.Date }} <br v-if="windowWidth <= 550" /> {{ history.Time }}{{ history.utcTime }}</em>
                    </h6>
                  </div>
  
                  <div class="chart_btn_container">
                    <img src="@/assets/images/dark/icon_chart.svg" v-if="!chartLoad[i]" />
                    <div class="loading_spinner coin_list" v-else>
                      <div class="loading_circle coin_list"></div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </template>
  
<script setup>
import { useI18n } from 'vue-i18n'
import { useRoute } from "vue-router";
import { defineProps, ref, computed, toRef, onUnmounted, onMounted, watch, defineEmits } from "vue";

import { chkPermission } from '@/utils/permission.js'

const props = defineProps({
  historyList: Array,
  insightList: Array,
  loadApi: Boolean,
  userPackage: Number
});
const { locale } = useI18n()

const route = useRoute();

const historyList = toRef(props, "historyList");
const insightList = toRef(props, "insightList");

const type = ref(route.query?.type);
const loadApi = toRef(props, "loadApi");
const loadingStatus = ref(false);
const searchQuery = ref("");
const subPath = ref(route.path.split("/")[2]);
const userId = ref(localStorage.getItem("userNum"));
const chartLoad = ref({});

// 권한 관련 
const userProPermission = ref(0); // 프리미엄 프로 권한 여부 
const okPro = ref(false); // 3000 이상 패키지 결제 여부 
const result = ref(null);
const checkingPermission = ref(true); // 체크 완료인지 확인
const userPackage = ref(localStorage.getItem("userPackage"));
const permission = ref(false); // 권한 확인
const okSmart = ref(false); // 10000 이상 패키지 결제 여부 
const isPayment = ref(0); // 결제여부
const alarmPayment = ref(false); // 결제여부

const emit = defineEmits(['openGuide']);
  
  
const filteredHistory = computed(() => {
  // 검색어가 없을 때는 coin 없어도 포함
  if (!searchQuery.value.trim()) {
    return historyList.value;
  }

  // 검색어가 있을 경우 coin이 있는 것만 필터링
  else {
    return historyList.value?.filter(
      (item) =>
        item.coin &&
        item.coin.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
  }
});

const insingtChk = computed(() =>
  insightList.value?.filter((item) => item.coin.toLowerCase().includes(searchQuery.value.toLowerCase()))
)

function clearSearch(event) {
  event.preventDefault();
  searchQuery.value = "";
}
  
function getImagePath(coin) {
  const symbol = coin + "USDT";
  const baseSymbol = symbol.replace("USDT", "").toLowerCase();
  try {
    return require("@/assets/images/coin_logos/" + baseSymbol + ".svg");
  } catch {
    return require("@/assets/images/coin_logos/default.svg");
  }
}

function handleImageError(symbol, event) {
  const baseSymbol = symbol.replace('USDT', '').toLowerCase();
  event.target.src = require('@/assets/images/coin_logos/' + baseSymbol + '.png');
}

const windowWidth = ref(window.innerWidth);
function updateWidth() {
  windowWidth.value = window.innerWidth;
}


onMounted(async () => {
  window.addEventListener("resize", updateWidth);
  
  try {
    await getPayment();

  } finally {
    checkingPermission.value = false;
  }


  setTimeout(() => {
    loadingStatus.value = true;
  }, 1000);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});

function responsiveText(label, value) {
  return windowWidth.value > 550 ? `${label}:<em>${value}</em>` : `${label}<br/><em>${value}</em>`;
}

function getSignBoxClass(history) {

  if (history.type == 'Dead') {
    history.type = 'Death'
  }

  if (type.value === "score") {
    return history.count > 1 ? "" : "new";
  }

  if (type.value === "smart") {
    return {
      plus: history.type === "L",
      minus: history.type === "S",
      gold: history.type === "Golden",
    };
  }

  if (type.value === "smart-pro") {
    return {
      plus: history.type === "LL",
      minus: history.type === "SS",
      yellow: history.type === "L" || history.type === "S",
    };
  }

  if (["premium", "premium-pro"].includes(type.value)) {
    return {
      plus: history.type.includes("L"),
      minus: history.type.includes("S"),
    };
  }

  if (subPath.value === "support-resistance") {
    if (history.position) {
      return {
        plus: history.position.includes("Buy"),
        minus: history.position.includes("Sell"),
      };
    }
  }

  if (subPath.value === "rocket" || type.value === "rsi") {
    return {
      plus: history.type == "L",
      minus: history.type == "S",
    }
  }
  return {};
}

  
// 차트로 이동 함수
function navigateToChart({symbol, i}) {
  chartLoad.value = {};
  chartLoad.value[i] = true;

  let url;
  let base_url = process.env.VUE_APP_CHART_URL;

  if (type.value === "score") {
    url = `${base_url}/chart/score-chart.php?symbol=${symbol.coin}&exchange_id=${symbol.excId}&user_id=${userId.value}&lang=${locale.value}&hour=50&count=${symbol.count}&type=score`;
  }

  else if (type.value === "volatility") {
    url = `${base_url}/chart/score-chart.php?symbol=${symbol.coin}&exchange_id=${symbol.excId}&user_id=${userId.value}&lang=${locale.value}&hour=50&count=${symbol.current}&type=volatility`;
  }

  else if (type.value === "smart") {
    url = `${base_url}/chart/smart-chart.php?symbol=${symbol.coin}&exchange_id=${symbol.excId}&user_id=${userId.value}&lang=${locale.value}&hour=50`;
  }

  else if (type.value === "premium" || type.value === "rsi") {
    url = `${base_url}/chart/chart.php?symbol=${symbol.coin}&exchange_id=${symbol.excId}&user_id=${userId.value}&lang=${locale.value}&hour=50`;
  }

  else if (type.value === "smart-pro") {
    url = `${base_url}/chart/smart-chart-pro.php?symbol=${symbol.coin}&exchange_id=${symbol.excId}&user_id=${userId.value}&lang=${locale.value}&hour=50`;
  }

  else if (type.value === "premium-pro") {
    url = `${base_url}/chart/chart-pro.php?symbol=${symbol.coin}&exchange_id=${symbol.excId}&user_id=${userId.value}&lang=${locale.value}&hour=50`;
  }

  else if (subPath.value === "support-resistance" || subPath.value === "rocket") {
    url = `${base_url}/chart/chart.php?symbol=${symbol.coin}&exchange_id=${symbol.excId}&user_id=${userId.value}&lang=${locale.value}&hour=50&is_sr=Y`;
  }

  window.location.href = url;
}

// 권한 없을시 알람, 검색 탭 없애기
function noPermission() {
  if (!alarmPayment.value) {
    return false;
  }

  if (type.value === 'premium-pro' && !userProPermission.value) {
    return false;
  }

  if (type.value === 'smart' && !okSmart.value || type.value === 'smart-pro' && !okSmart.value) {
    return false;
  }

  return true;
}

// 글자수에 따른 폰트 조정 > 급등락만
function getVolatilityClass(value) {
  const text = String(value);

  if (text.length > 10) return "vol-xl";
  if (text.length > 8) return "vol-lg";
  if (text.length > 6) return "vol-md";

  return "vol-sm";
}


// 패키지 결제여부 확인 함수 / 0 이면 권한 x 1 이면 권한 O
async function getPayment() {
  if (subPath.value == 'price') { return }

  result.value = await chkPermission();
  // console.log('result', result.value)

  permission.value = result.value.permission;
  okPro.value = result.value.okPro;
  okSmart.value = result.value.okSmart;
  isPayment.value = result.value.isPayment;
  userPackage.value = result.value.userPackage;
  alarmPayment.value = result.value.alarmPayment;

  if (Number(userPackage.value) < 1000 || Number(userPackage.value) <= 3000 &&  !alarmPayment.value) {
    emit('openGuide', 'permission');
    return;
  }

  if (okPro.value && alarmPayment.value || userPackage.value >= 5000) {
    userProPermission.value = true;
  }
}

watch(() => route.query.type, (newV) => {
  type.value = newV
  getPayment();
})
</script>

<style scoped>
.Tb_search_wrap.alarm.premium {
  top: 190px;
}

.vol-sm {
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px; 
}

.vol-md {
  font-size: 13px;
}

.vol-lg {
  font-size: 12px;
}

.vol-xl {
  font-size: 11px;
}

@media (max-width: 400px) {
  .ps_nodata {
    font-size: 14px;
    padding: 3rem 2rem;
  }
}
</style>